<template>
  <div class="activity-list">
    <div class="activity-info">
      <div class="location">
        <img :src="require('../../assets/img/location.png')" alt="">
        当前位置：
        <template v-for="(item, index) in pathList">
          <span :key="index" class="location-name" @click="$router.push(item.path)">{{ item.name }}  </span> >
        </template>
        活动列表
      </div>
    </div>
    <div class="activity-list-main">
      <div class="section">
        <div class="section-title">
          活动介绍
          <div class="bar" />
        </div>
      </div>
      <div style="width: 1160px;background-color:#FFFFFF;padding: 20px;margin-bottom: 15px;text-align: initial" v-html="activityDescription"></div>
      <div class="section">
        <div class="section-title">
          活动列表
          <div class="bar" />
        </div>
        <div v-for="(item, index) in activityList" :key="index" class="activity-item">
          <img v-if="item.coverImg" :src="$urlPrefix + item.coverImg" alt="">
          <div v-else class="coverArea" style="width: 270px;height: 188px">
            <p>{{ item.activityTitle }}</p>
          </div>
          <div class="content">
            <div class="title">
              <div :style="{backgroundColor: $typeColorMapping[item.activityType]}">
                {{ $typeMapping[item.activityType] }}
              </div>
              <span @click="goActivityDetail(item.pkid)">{{ item.activityTitle }}</span>
            </div>
            <p class="theme">活动主题: {{ themeMapping[item.activityTheme] }}</p>
            <p class="time">活动时间: {{ item.startTime }}</p>
            <p class="address">活动地址: {{ item.activityAddress }}</p>
          </div>
          <div class="process" :style="{backgroundColor: $processMapping[item.process].color}">
            {{ $processMapping[item.process].name }}
          </div>
          <div class="checkDetail" @click="goActivityDetail(item.pkid)">{{ item.process === 2 ? '立即报名' : '查看详情' }}</div>
        </div>
        <el-pagination
          background
          align="left"
          style="margin: 30px 30px"
          layout="total, prev, pager, next, jumper"
          :current-page="params.pageNumber"
          :page-sizes="[5, 10, 20, 30, 50]"
          :page-size="params.pageSize"
          :total="totalCount"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'ActivityMain',
  data() {
    return {
      pathList: [],
      currentPathList: [],
      themeMapping: {},
      params: {
        pageNumber: 1,
        pageSize: 5,
        specialPkid: ''
      },
      totalCount: 0,
      activityList: [],
      activityDescription: '',
      fromPath: {
        name: '',
        path: ''
      }
    }
  },
  created() {
    if (this.$route.query.pathList) {
      this.pathList = JSON.parse(this.$route.query.pathList)
      this.pathList = this.pathList.filter(item => item.name !== '活动列表')
      this.currentPathList = JSON.stringify([...this.pathList, {
        name: '活动列表',
        path: this.$route.fullPath
      }])
    }
    this.params.specialPkid = this.$route.query.pkid
    if (localStorage.getItem('themeMapping')) {
      this.themeMapping = JSON.parse(localStorage.getItem('themeMapping'))
    }
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$get('/front/index/specialActivityInfo', this.$route.query.pkid).then(res => {
        if (res) {
          if (res.bannerList){
            this.$emit('changeBannerList', res.bannerList)
          }
          this.activityDescription = res.specialContent
        }
      })
      this.getActivityList()
    },
    getActivityList() {
      this.$post('/front/index/activityPage', this.params).then(res => {
        if (res) {
          this.$emit('getActivityProcess', res.records)
          this.activityList = res.records
          this.totalCount = res.total
        } else {
          this.activityList = []
          this.totalCount = 0
        }
      })
    },
    handleCurrentChange(val) {
      this.params.pageNumber = val
      this.getActivityList()
    },
    goActivityDetail(pkid) {
      this.$router.push({
        path: '/activityDetail',
        query: {
          pkid: pkid,
          pathList: this.currentPathList
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.activity-list {
  background-color: #F6F6F5;
  padding-top: 25px;
  .activity-info {
    .location {
      width: 1200px;
      font-size: 14px;
      font-weight: 400;
      color: #363942;
      margin: 0 auto 25px auto;
      img {
        vertical-align: middle;
        margin-right: 10px;
      }
      .location-name {
        cursor: pointer;
        color: darkgray;
      }
      .location-name:hover {
        color: #EA5504;
      }
    }
    .activity-img {
      width: 100%;
      height: 100%;
    }
  }
  .activity-list-main {
    width: 1200px;
    margin: 0 auto;
    .section {
      padding: 30px 0;
      background-color: #F6F6F6;
      margin: 0 auto;
      .section-title {
        width: 100%;
        height: 78px;
        font-size: 48px;
        font-weight: 400;
        color: #333333;
        line-height: 48px;
        text-align: center;
      }
      .bar {
        width: 40px;
        height: 3px;
        background: #EA5504;
        margin: 15px auto 0 auto;
      }
      .activity-item {
        position: relative;
        width: 1200px;
        height: 218px;
        background: #FFFFFF;
        border-radius: 5px;
        box-sizing: border-box;
        padding: 15px 20px;
        margin-top: 30px;
        overflow: hidden;
        img {
          display: inline-block;
          width: 270px;
          height: 188px;
          border-radius: 6px;
          vertical-align: top;
        }
        .content {
          display: inline-block;
          width: 800px;
          height: 330px;
          margin-left: 20px;
          .title {
            height: 70px;
            line-height: 35px;
            margin-bottom: 30px;
            font-size: 22px;
            font-weight: bold;
            color: #363942;
            overflow: hidden;
            text-overflow: ellipsis ;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
            div {
              display: inline-block;
              width: 80px;
              height: 24px;
              font-size: 16px;
              line-height: 24px;
              background: #EA5504;
              border-radius: 5px;
              text-align: center;
              vertical-align: top;
              margin-top: 5px;
              margin-right: 10px;
              color: #FFFFFF;
            }
            span {
              cursor: pointer;
            }
            span:hover {
              color: #EA5504;
            }
          }
          p {
            width: 600px;
            font-size: 14px;
            font-weight: 400;
            color: #363942;
            margin-bottom: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .process {
          position: absolute;
          top: -60px;
          right: -60px;
          width: 120px;
          height: 120px;
          background-color: #0AC18F;
          font-size: 18px;
          text-align: center;
          color: #FFFFFF;
          line-height: 200px;
          transform: rotate(45deg);
          z-index: 10;
        }
        .checkDetail {
          position: absolute;
          right: 50px;
          bottom: 50px;
          width: 120px;
          height: 40px;
          line-height: 40px;
          background: #EA5504;
          border-radius: 2px;
          text-align: center;
          font-size: 18px;
          font-weight: 400;
          color: #FFFFFF;
          cursor: pointer;
        }
        .checkDetail:hover {
          opacity: 0.8;
        }
      }
      .activity-item:hover {
        box-shadow: 0 5px 8px 0 rgba(51, 51, 51, 0.1);
      }
    }
  }
}

</style>
